import { ReceiptState, ReceiptStateValue } from '@interfaces/receipts';
import { Source } from '@interfaces/source';
import { OrderStatus } from '@interfaces/order.ts';

export function checkReceiptIsProcessing(
  source: Source,
  receiptsState?: ReceiptState | null,
  orderStatus?: OrderStatus | null
) {
  const sourceState = receiptsState?.source[source];
  return (
    !!sourceState &&
    (sourceState.state === ReceiptStateValue.pending ||
      (sourceState.state === ReceiptStateValue.success &&
        orderStatus !== 'success'))
  );
}
